module.exports = __webpack_public_path__ + "img/neiyansuo-logo.c60daf32.png";